const zoomSettings = {
  zoomOnClick: true, // Habilita o zoom no click. Não utilizar junto de zoomOnHover.
  zoomOnHover: false, // Habilita o zoom no hover. Não utilizar junto de zoomOnClick.
  zoomPopup: true, // Habilita a exibição do popup.
  zoomOnPopup: true, // Habilita o zoom no popup.
  zoomFactor: 1.5 // Fator de zoom. O valor padrão é 1.5, o que significa que a imagem será ampliada em 50% do tamanho original.
}
 
export default zoomSettings
